export enum UserMemberUpdateStatusEnum {
    BAD_REQUEST = 400,
    NOT_AUTHORIZED = 401,
    NOT_EXISTING = 404,
    OK = 200,
}
